























































































































import Component from 'vue-class-component';
import FeedbackComponent from '@/components/base/FeedbackComponent';
import MockData from '@/globals/mock';
import EmployeeDetails from './EmployeeDetails.component.vue';
import AddressDetails from './AddressDetails.component.vue';
import ExtraInfoDetails from './ExtraInfoDetails.component.vue';
import SecondExtraInfoDetails from './SecondExtraInfoDetails.component.vue';
import { Action, Getter } from 'vuex-class';
import { DOCUMENTS, DOCUMENTS_ERRORS, DOWNLOAD_DOCUMENT, UPLOAD_CLICKED } from '@/types/documents.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Documents } from '@/models/form/Documents.model';
import { InputFile } from '@/models/InputFile.model';
import { FORM101_DATA, FORM_READ_ONLY_MODE } from '@/types/form.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { GET_MANAGER_DOCUMENT_CONTENT, MANAGER_MODE } from '@/types/managerForm.types';
import { UPLOAD_FILE_ENABLE } from '@/types/lobby.types';

@Component({
  components: {
    ExtraInfoDetails,
    SecondExtraInfoDetails,
    AddressDetails,
    EmployeeDetails,
  },
})
export default class PersonalDetailsStep extends FeedbackComponent {

  @Action(UPLOAD_CLICKED, StoreNamespace.DOCUMENT) public uploadClicked;
  @Action(DOWNLOAD_DOCUMENT, StoreNamespace.DOCUMENT) public downloadDocument;
  @Action(GET_MANAGER_DOCUMENT_CONTENT, StoreNamespace.MANAGER) public managerDownloadDocument;

  @Getter(MANAGER_MODE, StoreNamespace.MANAGER) public managerMode!: boolean;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(FORM_READ_ONLY_MODE, StoreNamespace.FORM) public formReadOnlyMode!: boolean;
  @Getter(DOCUMENTS, StoreNamespace.DOCUMENT) public documents!: Documents;
  @Getter(DOCUMENTS_ERRORS, StoreNamespace.DOCUMENT) public documentsErrors!: string[];
  @Getter(UPLOAD_FILE_ENABLE, StoreNamespace.AUTHENTICATION) public uploadFileEnable!: boolean;
  public upload201FileModal = false;

  private mockData: any = {};

  public created() {
    this.mockData = MockData.form101;
    this.upload201FileModal = false;
  }

  public open201FileDialog() {
    this.upload201FileModal = true;
  }

  public close201FileDialog() {
    this.upload201FileModal = false;
  }


  public onUploadClicked(inputFile: InputFile, docType: number) {
    this.uploadClicked(
        {
          requestBody: {
            inputFile,
            docType,
            formId: this.form101Data.formId,
          },
        });
  }

  public onDownloadClicked(file: InputFile) {
    if (this.managerMode) {
      this.managerDownloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
          officeNum: this.form101Data.officeNum,
          idNum: this.form101Data.idNum,
          positionNum: this.form101Data.positionNum,
        },
      });
    } else {
      this.downloadDocument({
        requestBody: {
          docId: file.docId,
          docName: file.docName,
          mimeType: file.type,
        },
      });
    }
  }

  public openDeleteDialog(index: number, files: any[]) {
    if (files[index].docId) {
      this.$root.$emit('openDeleteFileDialog', files[index]);
    }
  }
}
